import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {getIsFollowShop, getShopDetail, getShopVarieties, getShopSupplyList, getShopTel} from '@/api/miscellaneous';
import RestrictDialog from '@/components/RestrictDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SellerShop',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();

const isCollapse = ref(false);
const getListData = ref({
    id: (route.query.id || '') as string,
    page: 1,
    size: 10,
    categoryId: (route.query.categoryId || '') as string,
    quality: 0,
    upper: true,
});
const detail = ref<any>({});
const isFollow = ref(false);
const varieties = ref<any[]>([]);
const list = ref<any[]>([]);
const loading = ref(false);
const finished = ref(false);

const restrictShow = ref(false);
const restrictCode = ref('');
const tel = ref('');
const isShowTel = ref(false);

const getDetail = () => {
    getShopDetail({id: route.query.id as string}).then(res => {
        detail.value = res;
    });
};
getDetail();

const getFollow = () => {
    getIsFollowShop({id: route.query.id as string}).then(res => {
        isFollow.value = res as boolean;
    });
};
getFollow();

const getVarieties = () => {
    getShopVarieties({id: route.query.id as string}).then(res => {
        varieties.value = res as any[];
        // getListData.value.categoryId = (route.query.categoryId || '') as string;
    });
};
getVarieties();

const getList = () => {
    if (loading.value) return;
    loading.value = true;
    getShopSupplyList(getListData.value).then((res: any) => {
        loading.value = false;
        list.value = list.value.concat(res.items);
        finished.value = res.totalCount == 0 ? true : getListData.value.page * getListData.value.size > res.totalCount;
        getListData.value.page = getListData.value.page + 1;
    });
};
getList();
const search = () => {
    list.value = [];
    getListData.value.page = 1;
    getList();
};

const toSupplyDetail = (id: string) => {
    router.push({name: 'SupplyDetail', query: {id}});
};

const getTel = (): void => {
    let id = (route.query.id as string) || '';
    getShopTel({id})
        .then(res => {
            tel.value = res as string;
            isShowTel.value = true;
        })
        .catch(e => {
            let {code} = e;
            if ([121, 122].includes(code)) {
                restrictCode.value = code;
                restrictShow.value = true;
            }
        });
};

const __returned__ = { route, router, isCollapse, getListData, detail, isFollow, varieties, list, loading, finished, restrictShow, restrictCode, tel, isShowTel, getDetail, getFollow, getVarieties, getList, search, toSupplyDetail, getTel, ref, useRoute, useRouter, getIsFollowShop, getShopDetail, getShopVarieties, getShopSupplyList, getShopTel, RestrictDialog }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})